import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '@app/features/auth/auth.service';
import { environment } from '@env/environment';

export const apiPrefixInterceptor: HttpInterceptorFn = (request, next) => {
// alert('interceptor');
  const authServicio = inject(AuthService);

  // Prefijo del server
  if (!/^(http|https):/i.test(request.url)) {
    request = request.clone({ url: environment.serverUrl + request.url });
  }

  const auth_token = authServicio.obtenerToken();

  const header: Record<string, string> = {
    'Content-Type': 'application/json',
    'Ocp-Apim-Trace': 'true',
    Authorization: `Bearer ${auth_token}`,
  };

  const apiKeyHeader = environment.production ? 'key-api-prod' : 'key-api';
  header[apiKeyHeader] = environment.serverToken;

  request = request.clone({ setHeaders: header });

  return next(request);
};
